import { render, staticRenderFns } from "./clinicDoctorListing.vue?vue&type=template&id=8845902a&scoped=true"
import script from "./clinicDoctorListing.vue?vue&type=script&lang=js"
export * from "./clinicDoctorListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8845902a",
  null
  
)

export default component.exports